export default class StoreService {
  static callbacks = [];

  static onLogout(callback) {
    if (typeof callback === 'function') {
      this.callbacks.push(callback);
    } else {
      console.error('Callback must be a function.');
    }
  }
  static clearStore() {
    for (const callback of this.callbacks) {
      if (typeof callback === 'function') {
        callback();
      } else {
        console.error('Callback must be a function.');
      }
    }
    this.callbacks = [];
  }
}
